import { JScanifyCore } from './jscanifyCore';

/**
 * Lädt OpenCV.js (WASM) erst bei Bedarf per dynamischem Import - landet
 * nicht im normalen App-Bundle, sondern in einem eigenen Chunk, der nur beim
 * tatsächlichen Öffnen des Scanners nachgeladen wird (einmalig pro Browser,
 * danach HTTP-gecacht). `JScanifyCore` (vendored Algorithmus, siehe
 * `jscanifyCore.ts`) wird direkt mit dem geladenen `cv` instanziiert.
 */

interface ScannerRuntime {
  cv: any;
  scanner: JScanifyCore;
}

let loadPromise: Promise<ScannerRuntime> | null = null;

export function loadScanner(): Promise<ScannerRuntime> {
  if (!loadPromise) {
    // Bei Fehlern (z.B. Netzwerkabbruch beim mehrere-MB-Download) den
    // nächsten Aufruf nicht an einer fehlgeschlagenen Promise hängen lassen,
    // sondern einen erneuten Ladeversuch zulassen.
    loadPromise = initScanner().catch((err) => {
      loadPromise = null;
      throw err;
    });
  }
  return loadPromise;
}

async function initScanner(): Promise<ScannerRuntime> {
  const cvModule: any = await import('@techstark/opencv-js');
  const cvExport = cvModule.default ?? cvModule;
  const cv: any = await new Promise((resolve) => {
    if (cvExport instanceof Promise) {
      void cvExport.then(resolve);
    } else if (cvExport.Mat) {
      resolve(cvExport);
    } else {
      cvExport.onRuntimeInitialized = () => resolve(cvExport);
    }
  });

  return { cv, scanner: new JScanifyCore(cv) };
}
